import { ActivatedRoute, Router } from '@angular/router';
import { AiSummaryComponent } from '../../ai-summary/ai-summary.component';
import { CaseManagementService } from '../case-management.service';
import { PostTradeService } from '../../post-trade/post-trade.service';
import { CaseManagementData } from '../../models/case-management-model';
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { EnvironmentService } from '../../services/environment.service';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { getFilterMenuText } from '../../lib/rb-grid-lib';
import {
  KENDO_PDFVIEWER,
  PDFViewerTool,
} from '@progress/kendo-angular-pdfviewer';
import { LoadingDialogComponent } from '../../loading-dialog/loading-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxLoadingModule } from 'ngx-loading';
import { Platform } from '@angular/cdk/platform';
import { RightBridgeApiService } from '../../services/right-bridge-api.service';
import { saveAs } from '@progress/kendo-file-saver';
import { SessionStorageService } from '../../services/session-storage.service';
import { UnifiedFlowService } from '../../unified-flow/unified.service';
import { WarnDialogComponent } from '../../warn-dialog/warn-dialog.component';
import { BreadcrumbComponent } from '../../breadcrumb/breadcrumb.component';
import { Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import {
  MatAutocompleteModule,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { UtilityAppsComponent } from '../../shared-components/utility-apps/utility-apps.component';
import {
  NgxEditorComponent,
  NgxEditorMenuComponent,
  Editor,
  Toolbar,
} from 'ngx-editor';
import { MatDividerModule } from '@angular/material/divider';
import { UtilityAppsService } from '../../shared-components/utility-apps/utility-apps.service';
import { SpeechToTextComponent } from '../../shared-components/speech-to-text/speech-to-text.component';
import { AiSummaryResponse } from '../../models/post-trade-models';

@Component({
  selector: 'app-case-manager',
  templateUrl: './case-manager.component.html',
  styleUrls: ['./case-manager.component.scss'],
  imports: [
    AiSummaryComponent,
    BreadcrumbComponent,
    CommonModule,
    FormsModule,
    KENDO_PDFVIEWER,
    MatAutocompleteModule,
    MatButtonModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatOptionModule,
    MatSelectModule,
    MatTabsModule,
    MatTooltipModule,
    NgxEditorComponent,
    NgxEditorMenuComponent,
    NgxLoadingModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    SpeechToTextComponent,
  ],
})
export class CaseManagerComponent implements OnInit, OnDestroy {
  private cms = inject(CaseManagementService);
  private dialog = inject(MatDialog);
  private dialogRef = inject<MatDialogRef<CaseManagerComponent>>(MatDialogRef);
  private envSvc = inject(EnvironmentService);
  private params = inject(ActivatedRoute);
  private pltfrm = inject(Platform);
  private rbs = inject(RightBridgeApiService);
  private route = inject(Router);
  private snacky = inject(MatSnackBar);
  private ss = inject(SessionStorageService);
  private ptSvc = inject(PostTradeService);
  private uas = inject(UtilityAppsService);
  private unfFlowSvc = inject(UnifiedFlowService);

  @ViewChild(MatAutocompleteTrigger)
  assignedAutoComplete: MatAutocompleteTrigger;
  @ViewChild(MatMenuTrigger)
  cannedResponseMenuTrigger: MatMenuTrigger;
  public getFilterMenuText = getFilterMenuText;
  arrDeclaration = Array;
  activeCaseFile: any;
  aiSummaryText: string;
  aiSummaryTool = false;
  allowEditing = false;
  baseUrl: string;
  canDeleteFiles = false;
  canRespondToAssignee = false;
  canUploadFiles = false;
  canSpeechToText = false;
  caseDetails = {};
  filesLoading = false;
  caseFiles = null;
  caseHistoryData = [];
  caseHistoryHeaders = [
    { fieldName: 'AssignedToName', label: 'Assigned To' },
    { fieldName: 'DateLastUpdated', label: 'Updated' },
    { fieldName: 'SavedByName', label: 'Saved By' },
    { fieldName: 'StatusName', label: 'Status Name' },
    { fieldName: 'StatusChangeReasons', label: 'Status Reason' },
    { fieldName: 'Title', label: 'Title' },
    { fieldName: 'Type', label: 'Type' },
  ];
  caseProfile: CaseManagementData;
  caseProfileID: string;
  caseStatusChangeReasons: {
    StatusID: number;
    Reason: string;
  }[];
  caseTitle = '';
  caseUsers = [];
  changesMade;
  CRID: string;
  crumbConfig = [
    {
      label: 'Case Management',
      link: 'case-management',
    },
  ];
  defaultReviewerStatus: number;
  defaultUser;
  editCaseTitle = false;
  editMessage = '';
  editMessageId = null;
  editNoteType = 1;
  environment;
  file;
  fileName;
  fileNameDisplay;
  fileType;
  filteredAssignedToOptions: {
    Proximity: number;
    UserID: string;
    UserName: string;
    UserType: string;
  }[];
  globals = this.ss.get('globals');
  isCaseManager = false;
  loading = false;
  message = '';
  messages = [];
  mostRecentMessage = null;
  mostRecentUpdateItem = null;
  caseDescription = null;
  caseDescriptionIds = [];
  assignedToCtrl = new FormControl('');
  noteType = 1;
  noteTypes = [
    { value: 1, label: 'Public' },
    { value: 2, label: 'Private' },
  ];
  pdfBase64: any;
  pdfViewerTools: PDFViewerTool[] = [
    'pager',
    'spacer',
    'zoom',
    'zoomInOut',
    'selection',
  ];
  profileID: any;
  reassignOnSave = false;
  reportSettings = {};
  rights: string[];
  scrollInterval: ReturnType<typeof setTimeout>;
  selectedCaseFile = null;
  showCaseHistory = false;
  showPrintReportBtn = false;
  statusOptions: any = [];
  unsubscribe = new Subject();
  submittedBy: string;
  mostRecentUpdateReviewerItem: any;
  statusReasons: string[] = [];
  statusReasonsCtrl = new FormControl([]);
  html = '';
  editor: Editor;
  submittedEditor: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['ordered_list', 'bullet_list'],
  ];
  cannedResponses = [];
  typedText: string;
  usedVoice: boolean = false;
  voiceReviewed: boolean = false;
  externalTriggerStop: any;
  recordSelect = new FormControl('');

  ngOnInit() {
    this.uas.appsList.set([
      {
        label: 'Post Transaction',
        link: '/post-trade',
        right: 'PostTrade',
        icon: 'history_edu',
      },
    ]);
    this.editor = new Editor();
    this.params.params.subscribe(params => {
      this.CRID = params.CRID;
      this.crumbConfig.push({
        label: this.CRID,
        link: `case-management/case-manager/${this.CRID}`,
      });
    });
    this.loading = true;
    this.defaultUser = this.globals ? this.globals.user : null;
    this.profileID = this.ss.get('globals')
      ? this.ss.get('globals')['user']['id']
      : null;
    this.getCaseManagementProfile(this.CRID);
    this.getCaseRecordNotes(this.CRID);
    this.getCaseRecordFilesList(this.CRID);
    this.getCaseManagementHistory(this.CRID);
    this.rights = this.ss.get('rights');
    this.isCaseManager = this.rights && this.rights.includes('CaseManager');
    this.canDeleteFiles =
      this.rights && this.rights.includes('DeleteCMDocument');
    this.canUploadFiles = this.rights && this.rights.includes('CMUploadFiles');
    this.canRespondToAssignee =
      this.rights && this.rights.includes('RespondToAssignee');
    this.canSpeechToText = this.rights && this.rights.includes('SpeechToText');
    this.aiSummaryTool = this.rights && this.rights.includes('AISummaryAccess');
    this.environment = this.envSvc.get();
    this.baseUrl = this.environment.apiBase;

    this.assignedToCtrl.valueChanges
      .pipe(
        takeUntil(this.unsubscribe),
        startWith(''),
        map(value => this._filterAssigned(value || ''))
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.uas.appsList.set([]);
    this.editor.destroy();
    clearInterval(this.scrollInterval);
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  private _filterAssigned(value: string | { UserName: string }): void {
    const filterValue =
      typeof value === 'string'
        ? value.toLowerCase()
        : value.UserName.toLowerCase();

    this.filteredAssignedToOptions = this.caseUsers.filter(option => {
      return (
        option.UserName.toLowerCase().includes(filterValue) ||
        option.UserID.toLowerCase().includes(filterValue)
      );
    });
  }

  displayAssigned(assigned) {
    if (!assigned) {
      return null;
    } else if (assigned.UserName) {
      return assigned.UserName;
    } else if (assigned.UserID) {
      return assigned.UserID;
    } else {
      return null;
    }
  }

  changeAssigned(ev) {
    this.changeValue(true);
    this.caseProfile['CaseManagement']['AssignedTo'] = ev.option.value.UserID;
    this.filteredAssignedToOptions = this.caseUsers;
  }

  saveBtnDisabled() {
    if (
      this.canRespondToAssignee &&
      this.caseProfile?.CaseManagement?.AssignedTo === this.profileID &&
      new Date(this.mostRecentMessage?.CreateDate).getTime() -
        new Date(this.mostRecentUpdateItem?.DateLastUpdated).getTime() >=
        0
    ) {
      return false;
    }
    if (!this.canRespondToAssignee) {
      return !this.changesMade;
    }
    return true;
  }

  getCaseManagementProfile(id) {
    this.cms.getCaseManagementProfileData(id, 'FrontEnd').subscribe(resp => {
      this.caseProfile = resp;
      this.caseTitle = resp['CaseManagement']['Title'];
      this.submittedBy = resp['CaseManagement']['SubmittedBy'];
      this.caseDetails = resp['CaseManagement'];
      this.statusOptions = resp['ActiveStatuses'];
      this.reportSettings = resp['UnitCMReport'];
      this.showPrintReportBtn = resp['UnitCMReport']
        ? Boolean(
            resp['UnitCMReport']['ShowPrintButton'] &&
            resp['UnitCMReport']['PrintButtonStatuses'].includes(
              this.caseDetails['StatusID']
            )
          )
        : null;
      this.caseStatusChangeReasons = resp['UnitStatusChangeReasons']
        ? resp['UnitStatusChangeReasons'].filter(reason => reason?.Reason)
        : [];
      this.setupStatusReasons();

      if (resp['CannedResponses'] && resp['CannedResponses'].length > 0) {
        this.buildCannedResponseMenu(resp['CannedResponses']);
      }

      if (
        this.caseStatusChangeReasons &&
        this.caseStatusChangeReasons.length <= 0
      ) {
        const removeIndex = this.caseHistoryHeaders.findIndex(
          header => header.label === 'Status Reason'
        );

        if (removeIndex >= 0) {
          this.caseHistoryHeaders.splice(removeIndex, 1);
        }
      }
      if (this.canRespondToAssignee) {
        this.defaultReviewerStatus = resp['RespondToReviewer']?.DefaultStatusID;
      }
      if (resp['Client_Rep']?.['RepCode']?.[0]) {
        this.getCaseManagementUsers(resp['Client_Rep']['RepCode'][0]);
      }
      this.aiSummaryTool = resp['CMAISummary']['DisplayAISummary'];
      if (this.aiSummaryTool) {
        this.getAiSummary();

        this.aiSummaryText = resp['CMAISummaryResponse']
          ? resp['CMAISummaryResponse']['AISummary']
          : '';
      }
      this.allowEditing = resp['UnitMessageSettings']?.['AllowEditing'];
      this.loading = false;
    });
  }

  getAiSummary() {
    this.ptSvc
      .getAiSummary(this.CRID, 'aicasereview')
      .subscribe((resp: AiSummaryResponse) => {
        this.aiSummaryText = resp.result;
      });
  }

  getCaseManagementUsers(repCode) {
    this.cms.getCaseManagementUsers(repCode).subscribe(resp => {
      this.caseUsers = resp['Users'];
      this.filteredAssignedToOptions = this.caseUsers;
      this.assignedToCtrl.setValue(
        this.caseUsers.find(
          user =>
            user.UserID === this.caseProfile['CaseManagement']['AssignedTo']
        )
      );
      this.filteredAssignedToOptions = this.caseUsers;
    });
  }

  getCaseRecordFilesList(id) {
    this.filesLoading = true;
    this.cms.listCaseRecordFiles(id).subscribe(resp => {
      this.caseFiles = resp['data'];
      this.filesLoading = false;
    });
  }

  getCaseManagementHistory(id) {
    this.cms.getCaseManagementProfileData(id, 'AllVars').subscribe(resp => {
      this.caseHistoryData = resp['CaseManagementHistory'];
      this.caseProfileID = resp['CaseToProfile']?.ProfileID[0];
      this.caseHistoryData.forEach(caseItem => {
        caseItem.DateLastUpdated = new Date(
          `${caseItem.DateLastUpdated}Z` // UTC time modification because the DB value is tough for BE to modify
        ).toLocaleDateString('en-US', {
          hour: 'numeric',
          minute: 'numeric',
        });
      });
      this.showCaseHistory = true;
      let updateTimes = [];
      this.mostRecentUpdateItem = null;
      this.caseHistoryData.forEach(historyItem => {
        const thisItemTime =
          new Date().getTime() -
          new Date(historyItem.DateLastUpdated).getTime();
        updateTimes.push(thisItemTime);
        if (Math.min(...updateTimes) === thisItemTime) {
          this.mostRecentUpdateItem = historyItem;
        }
      });
      updateTimes = [];
      this.caseHistoryData
        .filter(
          caseItem => caseItem.AssignedToUserType.toLowerCase() === 'reviewer'
        )
        .forEach(historyItem => {
          const thisItemTime =
            new Date().getTime() -
            new Date(historyItem.DateLastUpdated).getTime();
          updateTimes.push(thisItemTime);
          if (Math.min(...updateTimes) === thisItemTime) {
            this.mostRecentUpdateReviewerItem = historyItem;
          }
        });
    });
  }

  setupStatusReasons(): void {
    this.statusReasons = [];
    this.caseStatusChangeReasons.forEach(reason => {
      if (
        this.caseDetails['StatusChangeReasons'] &&
        this.caseDetails['StatusChangeReasons'].includes(reason.Reason)
      ) {
        this.statusReasons.push(reason.Reason);
      }
    });
    this.statusReasonsCtrl.setValue(this.statusReasons);
  }

  statusReasonsChange(reasonsList) {
    this.updateReason(reasonsList);
  }

  changeStatus() {
    this.statusReasons = [];
    this.statusReasonsCtrl.setValue(this.statusReasons);
    this.changeValue(true);
  }

  updateReason(reasonsList) {
    this.changeValue(true);
    this.statusReasons = reasonsList;
    this.caseProfile['CaseManagement']['StatusChangeReasons'] =
      this.statusReasons;
  }

  onFileSelected(event) {
    this.file = event.target.files[0];

    if (this.file) {
      this.fileName = this.file.name;
    }
  }

  getCaseRecordFile(caseFile) {
    this.loading = true;
    this.cms.getCaseRecordFile(caseFile.id).subscribe(resp => {
      const filename = `${caseFile.Name}`;
      const iosSafari =
        this.pltfrm.IOS ||
        (navigator?.['userAgentData']?.platform === 'macOS' &&
          navigator.maxTouchPoints > 1);
      let fileData;
      const reader = new FileReader();
      reader.readAsDataURL(resp);
      reader.onloadend = () => {
        fileData = reader.result;
        saveAs(fileData, filename, {
          proxyURL: `${this.baseUrl}/util/proxy`,
          proxyTarget: '_self',
          forceProxy: iosSafari,
        });
        this.loading = false;
      };
    });
  }

  loadFileIntoViewer(caseFile) {
    this.cms.getCaseRecordFile(caseFile.id).subscribe(resp => {
      this.activeCaseFile = caseFile.Name;
      let viewFileData;
      const reader = new FileReader();
      reader.readAsDataURL(resp);
      reader.onloadend = () => {
        viewFileData = reader.result;
        this.pdfBase64 = viewFileData.replace(
          'data:application/octet-stream;base64,',
          ''
        );
      };
    });
  }

  deleteCaseRecordFile(caseFile) {
    let dialogRef = this.dialog.open(WarnDialogComponent, {
      panelClass: 'warn-dialog',
      data: {
        headline: 'Warning',
        content: `Are you sure you want to delete ${caseFile.Name}.${caseFile.Type}?`,
        confirm: 'Yes',
        hideCancel: false,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'continue') {
        this.cms.deleteCaseRecordFile(caseFile.id).subscribe(() => {
          this.getCaseRecordFilesList(this.CRID);
        });
      }
      dialogRef = null;
    });
  }

  getCaseRecordNotes(id) {
    this.cms.getCaseRecordNotes(id).subscribe(resp => {
      this.messages = resp['data'];
      this.scrollToBottom();
      const updateTimes = [];
      this.mostRecentMessage = null;
      this.messages.forEach(message => {
        if (message.CreatedByUserId === this.profileID) {
          const thisItemTime =
            new Date().getTime() - new Date(message.CreateDate).getTime();
          updateTimes.push(thisItemTime);
          if (Math.min(...updateTimes) === thisItemTime) {
            this.mostRecentMessage = message;
          }
        }
        if (message.NoteTypeId === '3' || message.NoteTypeId === 3) {
          this.caseDescription = message;
        }
      });
    });
  }

  submitNote() {
    const newNote = {
      CaseRecordId: this.CRID,
      NoteText: this.message,
      NoteTypeId: this.noteType === 1 ? 1 : this.noteType,
    };

    this.cms.addCaseRecordNote(newNote).subscribe(() => {
      this.getCaseRecordNotes(this.CRID);
      this.message = '';
      this.typedText = '';
      this.usedVoice = false;
      this.voiceReviewed = false;
    });
  }

  editNote(note) {
    this.submittedEditor = new Editor();
    this.editMessageId = note.NoteId;
    this.editMessage = note.NoteText;
    this.editNoteType = note.NoteTypeId * 1;
  }

  submitEdit() {
    const saveNote = {
      CaseRecordId: this.CRID,
      NoteText: this.editMessage,
      NoteTypeId: this.editNoteType,
      NoteId: this.editMessageId,
    };
    this.cms.editCaseRecordNote(saveNote).subscribe(() => {
      this.getCaseRecordNotes(this.CRID);
      this.message = '';
      if (this.editNoteType === 3) {
        this.snacky.open('Case Description saved!', 'Close', {
          duration: 4000,
        });
      }
      this.editMessageId = null;
      this.editMessage = null;
      this.editNoteType = null;
      this.submittedEditor.destroy();
    });
  }

  scrollToBottom() {
    const chatContainer = document.querySelector('.chat-messages-container');
    if (chatContainer) {
      if (this.loading) {
        this.scrollInterval = setInterval(() => this.scrollToBottom(), 200);
      } else {
        clearInterval(this.scrollInterval);
        const oldScrollPostion = chatContainer?.scrollHeight;
        chatContainer.scrollTo({
          top: oldScrollPostion,
          left: 0,
          behavior: 'smooth',
        });
      }
    }
  }

  changeValue(value) {
    this.changesMade = value;
  }

  isArray(value) {
    return Array.isArray(value);
  }

  saveCaseChanges() {
    this.loading = true;
    let snackyMessage = 'Saved!';
    const caseDetails = this.caseProfile;

    let assignedToName =
      this.caseUsers.find(
        user => user.UserID === this.caseProfile['CaseManagement']['AssignedTo']
      )?.UserName || null;

    if (this.canRespondToAssignee) {
      const updateTimes = [];
      let tempAssignedTo = this.caseProfile['CaseManagement']['AssignedTo'];
      let tempAssignedToName = assignedToName;
      this.caseHistoryData.forEach(dataItem => {
        if (dataItem.AssignedToName !== assignedToName) {
          const thisItemTime =
            new Date().getTime() - new Date(dataItem.DateLastUpdated).getTime();
          updateTimes.push(thisItemTime);
          if (Math.min(...updateTimes) === thisItemTime) {
            tempAssignedToName = dataItem.AssignedToName;
            tempAssignedTo = dataItem.AssignedTo;
          }
        }
      });
      this.caseProfile['CaseManagement']['AssignedTo'] = tempAssignedTo;
      assignedToName = tempAssignedToName;
      snackyMessage = `Saved and Assigned to ${assignedToName}`;
      caseDetails['CaseManagement']['StatusID'] = this.defaultReviewerStatus
        ? this.defaultReviewerStatus
        : this.caseProfile['CaseManagement']['StatusID'];
    }

    caseDetails['CaseManagement']['AssignedToName'] = assignedToName;

    this.cms.saveCaseManagementRecord(this.CRID, caseDetails).subscribe(() => {
      this.snacky.open(snackyMessage, 'Close', {
        duration: 5000,
      });
      this.message = '';
      this.changeValue(false);
      this.getCaseRecordNotes(this.CRID);
      this.getCaseManagementProfile(this.CRID);
      this.getCaseManagementHistory(this.CRID);
      this.loading = false;
    });
  }

  completeFileUpload() {
    this.loading = true;
    const formData = new FormData();
    const fileName = this.file['name'];
    const fileType = this.file['type'];
    formData.append('File1', this.file);
    this.fileName = '';
    this.cms
      .saveCaseRecordFile(this.CRID, formData, fileName, fileType)
      .subscribe({
        next: () => {
          this.getCaseRecordNotes(this.CRID);
          this.getCaseRecordFilesList(this.CRID);
          this.message = '';
          this.snacky.open(
            'File uploaded, please allow some time for it to appear in your new Case Management record.',
            'Close',
            {
              duration: 3000,
            }
          );

          this.loading = false;
        },
        error: error => {
          this.snacky.open(`There was an error uploading the file.`, 'Close', {
            duration: 10000,
          });

          this.loading = false;
        },
      });
  }

  saveCaseTitle() {
    this.caseProfile['CaseManagement']['Title'] = this.caseTitle;
    this.saveCaseChanges();
    this.toggleEditCaseTitle(false);
  }

  cancelEditCaseTitle() {
    this.caseTitle = this.caseProfile['CaseManagement']['Title'];
    this.toggleEditCaseTitle(false);
  }

  toggleEditCaseTitle(value) {
    this.editCaseTitle = value;
  }

  submitPostback() {
    let warnDialogRef = this.dialog.open(WarnDialogComponent, {
      panelClass: 'warn-dialog',
      data: {
        headline: 'Are you sure?',
        content: `You want to submit this case?`,
        confirm: 'Yes',
        hideCancel: false,
      },
    });

    warnDialogRef.afterClosed().subscribe(result => {
      if (result === 'continue') {
        this.rbs.postback(this.caseDetails['CRID'], 'cm').subscribe(() => {
          this.snacky.open('Case successfully submitted!', 'Close', {
            duration: 3000,
          });
          this.dialogRef.close({ data: 'submitted' });
        });
      }
      warnDialogRef = null;
    });
  }
  printCMReport(ev) {
    this.unfFlowSvc.setLoading(true);
    const dialogRef = this.dialog.open(LoadingDialogComponent, {
      panelClass: 'app-loading-dialog',
      data: {
        headline: 'Please wait',
        content: 'Your report is generating. This may take a moment...',
      },
      disableClose: true,
    });
    const payload = {
      ReportType: 'casemanagement',
      profileID: this.caseDetails['CRID'],
      UIConfig: 'cm-report',
    };

    this.rbs.getCustomReport(payload, 'cm').subscribe(data => {
      const date = new Date();
      const filename =
        'RightBridge-Report-' +
        (date.getMonth() + 1) +
        date.getDate() +
        date.getFullYear() +
        '.pdf';

      const iosSafari =
        this.pltfrm.IOS ||
        (navigator?.['userAgentData']?.platform === 'macOS' &&
          navigator.maxTouchPoints > 1);

      let fileData;
      const reader = new FileReader();
      reader.readAsDataURL(data);
      reader.onloadend = () => {
        fileData = reader.result;
        saveAs(fileData, filename, {
          proxyURL: `${this.baseUrl}/util/proxy`,
          proxyTarget: '_self',
          forceProxy: iosSafari,
        });

        if (dialogRef) {
          dialogRef.componentInstance.headline = 'Complete!';
          dialogRef.componentInstance.content =
            'Your report has been generated! Thank you for your patience.';
          dialogRef.componentInstance.endModal();
        }
        this.unfFlowSvc.setLoading(false);
      };
    });
  }
  nav(location) {
    if (this.changesMade) {
      let warnDialogRef = this.dialog.open(WarnDialogComponent, {
        panelClass: 'warn-dialog',
        data: {
          headline: 'Are you sure?',
          content: `You have unsaved changes. Would you like to leave this page?`,
          confirm: 'Yes',
          hideCancel: false,
        },
      });

      warnDialogRef.afterClosed().subscribe(result => {
        if (result === 'continue') {
          if (location === 'caseSummary') {
            if (this.caseProfileID) {
              this.route.navigate([`/case/summary/${this.caseProfileID}/0`]);
            } else {
              this.snacky.open(
                'There was an error navigating to this case. Please contact your administrator.',
                'Close',
                {
                  duration: 8000,
                }
              );
            }
          } else {
            this.route.navigate([`/${location}`]);
          }
        }
        warnDialogRef = null;
      });
    } else {
      if (location === 'caseSummary') {
        if (this.caseProfileID) {
          this.route.navigate([`/case/summary/${this.caseProfileID}/0`]);
        } else {
          this.snacky.open(
            'There was an error navigating to this case. Please contact your administrator.',
            'Close',
            {
              duration: 8000,
            }
          );
        }
      } else {
        this.route.navigate([`/${location}`]);
      }
    }
  }
  expand(ev, currentCard: string) {
    const el = ev.target.closest(`.${currentCard}`);
    if (el) {
      el.classList.toggle('expanded');
    }
  }
  parseCaseDescription(caseDescriptionNote) {
    if (caseDescriptionNote.includes('~')) {
      const tradeCaseMessage = caseDescriptionNote.split('~')[0];
      this.caseDescriptionIds = caseDescriptionNote.split('~')[1].split('|');
      return tradeCaseMessage;
    } else {
      return caseDescriptionNote;
    }
  }
  recordType(caseDescriptionNote) {
    if (caseDescriptionNote.includes('account')) {
      return 'Account';
    } else if (caseDescriptionNote.includes('rep')) {
      return 'Rep';
    } else if (caseDescriptionNote.includes('aml')) {
      return 'Alert';
    }
    return 'Trade';
  }
  messageListCheck() {
    return (
      this.messages.filter(
        message => message.NoteTypeId !== 3 && message.NoteTypeId !== '3'
      ).length > 0
    );
  }
  buildCannedResponseMenu(respData) {
    const formattedResp = [];

    respData.map(cannedResp => {
      const existingResponse = formattedResp.find(
        resp => resp.AlertID === cannedResp.AlertID
      );
      if (!existingResponse) {
        formattedResp.push({
          AlertID: cannedResp.AlertID,
          Responses: [cannedResp.Response],
        });
      } else {
        existingResponse.Responses.push(cannedResp.Response);
      }
    });

    this.cannedResponses = formattedResp;
  }
  selectCannedResponse(ev, respString) {
    ev.stopPropagation();
    ev.preventDefault();
    this.message += `<p>${respString}</p>`;
    this.updateTypedText({});
    this.cannedResponseMenuTrigger.closeMenu();
    this.editor.commands.focus();
  }

  applySpeechToTextNote(ev) {
    this.message = ev;
    this.typedText = this.message;
    this.voiceReviewed = false;
    this.usedVoice = true;
  }

  applySpeechToTextError(ev) {
    if (ev !== 'reset') {
      this.snacky.open(ev, 'Close', {
        duration: 8000,
      });
    }
  }

  updateTypedText(ev) {
    if (this.canSpeechToText) {
      this.externalTriggerStop = ev;
      const lastPTagIndex = this.message.lastIndexOf('</p>');
      if (lastPTagIndex !== -1) {
        this.typedText =
          this.message.substring(0, lastPTagIndex) +
          this.message.substring(lastPTagIndex + 4);
      } else {
        this.typedText = this.message;
      }
    }
  }

  speechReviewEvent(ev) {
    this.voiceReviewed = ev.checked;
  }
}
